import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "@bookips/solvook-ui-library";
import { Typography } from "@mui/material";
import { TabMessageBox } from "./PurchaseLayouts";
const PurchaseUnavailableTab = ()=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TabMessageBox, {
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "subtitle1",
                    sx: {
                        color: "red.400"
                    },
                    children: "판매가 중지된 상품이에요."
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                size: "large",
                variant: "contained",
                fullWidth: true,
                disabled: true,
                sx: {
                    mt: 2
                },
                children: "장바구니 담기"
            })
        ]
    });
};
export default PurchaseUnavailableTab;
